/**
 * StatBand — the horizontal KPI strip used across the report screens. Values
 * are display strings already formatted upstream; this component only lays them
 * out. Large, tabular, tablet-friendly.
 */
export interface Stat {
  label: string;
  value: string;
  /** Optional accent: "ops" (amber), "good", "warn", "crit". */
  tone?: "ops" | "good" | "warn" | "crit";
  sub?: string;
}

export function StatBand({ stats }: { stats: Stat[] }) {
  return (
    <div className="statband">
      {stats.map((s) => (
        <div key={s.label} className={`stat${s.tone ? ` stat-${s.tone}` : ""}`}>
          <span className="stat-label">{s.label}</span>
          <div className="stat-value">
            {s.value}
            {s.sub ? <small> {s.sub}</small> : null}
          </div>
        </div>
      ))}
    </div>
  );
}
